import React from 'react'
import { Outlet, Navigate, Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingSpinner } from '../ui/LoadingSpinner'
import { FiShoppingBag, FiUser, FiLogOut, FiHome, FiPackage } from 'react-icons/fi'
import '../../styles/client-layout.css'

export const ClientLayout: React.FC = () => {
  const { user, isLoading, logout } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (user.role !== 'client') {
    // Redirect admins to admin panel
    if (user.role === 'admin' || user.role === 'superadmin') {
      return <Navigate to="/admin" replace />
    }
    // Other roles go to public site
    return <Navigate to="/" replace />
  }

  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  const isActive = (path: string) => {
    return location.pathname.startsWith(path)
  }

  return (
    <div className="client-layout">
      {/* Header */}
      <header className="client-header">
        <div className="client-header-content">
          <div className="client-header-brand">
            <Link to="/" className="client-logo">
              <img src="/images/chefmax_logo.png" alt="ChefMax" className="h-8" />
              <span className="client-logo-text">ChefMax</span>
            </Link>
          </div>

          <nav className="client-nav">
            <Link 
              to="/client" 
              className={`client-nav-link ${isActive('/client') && location.pathname === '/client' ? 'active' : ''}`}
            >
              <FiHome />
              <span>Inicio</span>
            </Link>
            <Link 
              to="/client/orders" 
              className={`client-nav-link ${isActive('/client/orders') ? 'active' : ''}`}
            >
              <FiPackage />
              <span>Mis Pedidos</span>
            </Link>
            <Link 
              to="/" 
              className="client-nav-link"
            >
              <FiShoppingBag />
              <span>Catálogo</span>
            </Link>
          </nav>

          <div className="client-header-actions">
            <div className="client-user-menu">
              <div className="client-user-info">
                <FiUser />
                <span>{user.firstName} {user.lastName}</span>
              </div>
              <button onClick={handleLogout} className="client-logout-btn">
                <FiLogOut />
                <span>Salir</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="client-main">
        <div className="client-container">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="client-footer">
        <div className="client-container">
          <div className="client-footer-content">
            <p>&copy; 2025 ChefMax Latam. Todos los derechos reservados.</p>
            <div className="client-footer-links">
              <Link to="/terms">Términos y Condiciones</Link>
              <Link to="/privacy">Política de Privacidad</Link>
              <Link to="/support">Soporte</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
